var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"justify-center"},[_c('v-col',{attrs:{"sm":"5"}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNextPage),expression:"isNextPage"}],staticClass:"font-weight-bold",attrs:{"block":"","large":"","color":"honey"},on:{"click":_vm.nextPage}},[_vm._v(" Load more ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }